export default {
  attachmentItemComponent: 'attachment-item-pill',
  allowMediaInserter: false,
  allowMention: true,
  allowAttribute: false,
  autoFocusBottomRight: false,
  autoFocusTopLeft: false,
  urlReplacement: false,
  allowImage: true,
  allowButton: false,
  allowVideo: true,
  allowSocial: false,
  allowHeading: true,
  allowSubheading: true,
  recoverErrors: true,
  allowEmoji: true,
  allowSavedReplies: false,
  allowMarkdownHeadings: false,
  markdownInlineCode: true,
  stripEmptyTrailingBlocks: true
};